import { MiddlewareAction } from "../middleware";

export enum UserWorkInfoActions {
  REQUEST_GET_USER_WORK_INFO = "REQUEST_GET_USER_WORK_INFO",
}

export function getUserWorkInfo(userId: string): MiddlewareAction {
  return {
    actionName: UserWorkInfoActions.REQUEST_GET_USER_WORK_INFO,
    type: "GET",
    url: "/user/work-info",
    queryParams: {
      userId,
    },
  };
}
